<script>
    import _ from 'lodash';
    import {download} from '../../utils.js';
    import {store} from '../../stores.js';

    const user = store('credential', 'getAuth');
    const sort = store('material-sort', '', '"order"');

    export let args;

    let price_type = 'opt'

    const export_csv = () => {
        let type = decodeURIComponent(location.href.split('/').pop());
        let data = [
            ['Материал', 'Количество', 'Ед. изм.', '%', 'Цена', 'Стоимость'].join(';')
        ]

        for (const [material, {count, quantity, type, spis, oprice, price}] of Object.entries(args?.item?.materials ?? {})) {
            data.push(
                [
                    material,
                    parseFloat(count * (1 + spis / 100) * (quantity || 1)),
                    type,
                    parseFloat(spis),
                    parseFloat(oprice[price_type]),
                    parseFloat(price[price_type] * (quantity || 1))
                ].join(';')
            )
        }

        download('Расчёт материала для ' + type + '.csv', data.join("\n"));
    };
</script>

{#if args.item && args.item.quantity && Object.entries(args.item.materials ?? {}).length > 0}
    <div class="card-header px-2 py-1">
        <div class="row">
            <div class="col-6 d-flex align-items-center">Результат расчёта</div>
            <div class="col-6">
                <div class="row">
                    <div class="col-4">
                        <div class="btn-group w-100">
                            <button class="btn btn-link {$sort === 'title' ? 'text-primary' : 'text-dark'} p-0 m-0 border-0" on:click={() => sort.save('title')}>
                                <i class="fas fa-sort-alpha-down fa-lg"></i>
                            </button>
                            <button class="btn btn-link {$sort === 'order' ? 'text-primary' : 'text-dark'} p-0 m-0 border-0" on:click={() => sort.save('order')}>
                                <i class="fas fa-sort-numeric-down fa-lg"></i>
                            </button>
                            <button class="btn btn-link text-dark p-0 m-0 border-0" on:click={export_csv}>
                                <i class="fas fa-download fa-lg"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-8">
                        <select id="price_type" class="form-control gap-2 form-select" bind:value={price_type}>
                            {#if $user && $user.tip.toLowerCase().includes('главный')}
                                <option value="rozn" selected>Розничная цена</option>
                            {/if}
                            <option value="opt">Дилерская цена</option>
                            {#if $user && $user.tip.toLowerCase().includes('администратор')}
                                <option value="sebest">Закупочная цена</option>
                            {/if}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body p-0 overflow-auto">
        <table class="table">
            <thead>
                <tr>
                    <th class="col">Материал</th>
                    <th class="col-1" style="text-align: right">
                        <span class="d-inline d-md-none"><b>Кол-во.</b></span>
                        <span class="d-none d-md-inline"><b>Количество</b></span>
                    </th>
                    <th class="col-1" style="text-align: right">%</th>
                    <th class="col-1" style="text-align: right">Цена</th>
                    <th class="col-1" style="text-align: right">
                        <span class="d-inline d-md-none"><b>Стоим.</b></span>
                        <span class="d-none d-md-inline"><b>Стоимость</b></span>
                    </th>
                </tr>
            </thead>

            <tbody>
                {#each _.sortMaterials(args.item.materials ?? {}, $sort) as material, i}
                    <tr>
                        <td><span class="clamp">{material.title}</span></td>
                        <td style="text-align: right; font-family: monospace;">{((material.count * (1 + material.spis / 100) * (material.quantity || 1))).toFixed(2)}/{material.type?.replace(/\.$/, "") ?? ''}</td>
                        <td style="text-align: right; font-family: monospace;">{(+material.spis).toFixed(1)}</td>
                        <td style="text-align: right; font-family: monospace;">{(+material.oprice[price_type]).toLocaleString()}</td>
                        <td style="text-align: right; font-family: monospace;">{(material.price[price_type] * (material.quantity || 1)).toLocaleString()}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}

<style>
    .clamp {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
